export interface ContractJOCCreateRequest {
  contractName: string;
  vendorId: string;
  executedDate: string;
  endDate: string;
  comment: string;
}
